import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { VIDEO_TYPE } from '../types.js';
import { Uploader, handleUploadFinished, handleUploadStart } from 'wix-rich-content-plugin-commons';
import { MediaUploadModal } from 'wix-rich-content-ui-components';
import { MEDIA_POPOVERS_BUTTONS_NAMES_BI } from 'wix-rich-content-common';
import { VideoPluginService } from './videoPluginService.js';
import 'lodash';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class VideoUploadModal extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "closeModal", () => {
      this.props.closeModal();
    });
    __publicField(this, "getOnUploadFinished", (isCustomVideo) => {
      return ({ data, error }) => {
        this.setComponentData(__spreadProps(__spreadValues({}, data), { error, isCustomVideo }));
      };
    });
    __publicField(this, "addVideoComponent", ({ data, error }, isCustomVideo = false) => {
      const { uploadService } = this.props;
      if (uploadService) {
        this.uploadContextOnConfirm(data);
      } else {
        handleUploadFinished(
          VIDEO_TYPE,
          this.getComponentData,
          data,
          error,
          ({ data: data2, error: error2 }) => this.onConfirm(__spreadProps(__spreadValues({}, data2), { error: error2, isCustomVideo }))
        );
      }
    });
    __publicField(this, "setComponentData", (data) => {
      this.props.pubsub.set("componentData", data, this.blockKey);
    });
    __publicField(this, "onLocalLoad", ({ src, tempData }) => {
      this.onConfirm(__spreadProps(__spreadValues({}, this.props.componentData), { src, isCustomVideo: true, tempData }));
    });
    __publicField(this, "getComponentData", () => this.props.componentData);
    __publicField(this, "handleNativeFileUpload", (file) => {
      const { uploadService, onConfirm } = this.props;
      if (uploadService) {
        if (onConfirm && !this.blockKey) {
          const { newBlock } = onConfirm(__spreadProps(__spreadValues({}, this.props.componentData), { isCustomVideo: true }));
          this.blockKey = newBlock.key;
        }
        setTimeout(
          () => uploadService.uploadFile(
            file,
            this.blockKey || this.props.blockKey,
            this.Uploader,
            VIDEO_TYPE,
            this.VideoPluginService
          ),
          50
        );
      } else {
        handleUploadStart(
          this.props,
          this.getComponentData,
          file,
          this.onLocalLoad,
          this.getOnUploadFinished(true)
        );
      }
      this.closeModal();
    });
    const { componentData, disableDownloadDefault } = props;
    this.state = {
      url: !componentData.isCustomVideo && componentData.src || ""
    };
    this.id = `VideoUploadModal_FileInput_${Math.floor(Math.random() * 9999)}`;
    const { onConfirm, onReplace } = props;
    this.onConfirm = (obj) => {
      if (onConfirm) {
        const { newBlock } = onConfirm(obj);
        this.blockKey = newBlock.key;
      } else {
        onReplace(obj, this.blockKey);
      }
    };
    this.VideoPluginService = new VideoPluginService({ disableDownloadDefault });
    this.Uploader = new Uploader(props.handleFileUpload);
    this.uploadContextOnConfirm = (data, isCustomVideo) => {
      if (onConfirm) {
        const componentData2 = this.VideoPluginService.createPluginData(
          { data },
          this.props.componentData
        );
        const { newBlock } = onConfirm(__spreadProps(__spreadValues({}, componentData2), { isCustomVideo }));
        this.blockKey = newBlock.key;
      } else {
        this.props.updateService.updatePluginData(
          { data },
          this.blockKey || this.props.blockKey,
          VIDEO_TYPE,
          this.VideoPluginService
        );
      }
    };
  }
  render() {
    const {
      t,
      handleFileSelection,
      handleFileUpload,
      enableCustomUploadOnMobile,
      isMobile,
      languageDir,
      helpers
    } = this.props;
    const hasCustomFileUpload = handleFileUpload || handleFileSelection;
    const showUploadSection = (!isMobile || enableCustomUploadOnMobile) && hasCustomFileUpload;
    const handleClick = (evt) => {
      var _a;
      (_a = helpers == null ? void 0 : helpers.onPluginsPopOverClick) == null ? void 0 : _a.call(helpers, {
        pluginId: VIDEO_TYPE,
        buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.upload
      });
      if (handleFileSelection) {
        evt.preventDefault();
        this.closeModal();
        return handleFileSelection(({ data, error }) => {
          this.addVideoComponent({ data, error }, true);
        });
      }
    };
    return /* @__PURE__ */ React.createElement(
      MediaUploadModal,
      {
        id: this.id,
        isMobile,
        handleClick,
        handleChange: this.handleNativeFileUpload,
        languageDir,
        title: t("VideoCustomUploadModal_Title"),
        labelText: t("VideoUploadModal_CustomVideoClickText"),
        dataHook: "videoUploadModalCustomVideo",
        showUploadSection,
        accept: "video/*"
      }
    );
  }
}
VideoUploadModal.propTypes = {
  onReplace: PropTypes.func,
  onConfirm: PropTypes.func,
  pubsub: PropTypes.object,
  helpers: PropTypes.object.isRequired,
  componentData: PropTypes.object.isRequired,
  url: PropTypes.string,
  theme: PropTypes.object.isRequired,
  t: PropTypes.func,
  handleFileSelection: PropTypes.func,
  handleFileUpload: PropTypes.func,
  enableCustomUploadOnMobile: PropTypes.bool,
  isMobile: PropTypes.bool,
  languageDir: PropTypes.string,
  blockKey: PropTypes.string,
  uploadService: PropTypes.func,
  updateService: PropTypes.func,
  closeModal: PropTypes.func,
  disableDownloadDefault: PropTypes.bool
};

export { VideoUploadModal as default };
//# sourceMappingURL=videoUploadModal.js.map
